import './SidebarWidget.css';

export function SidebarWidget({ title, children }) {
    return (
        <div className="sw">
            <div className="sw-header">
                <span className="sw-title">{title}</span>
            </div>
            <div className="sw-body">
                {children}
            </div>
        </div>
    );
}
